// From inc/ directory
import "./inc/map_search.js";
import "./inc/read_more.js";
import "./inc/retail_user.js";

// Formerly in vendor.footer.js
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";

// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// =============================================================================
// get the sticky element
const stickyElm = document.querySelector('.main-navbar')

const observer = new IntersectionObserver(
  ([e]) => e.target.classList.toggle('stuck', e.intersectionRatio < 1),
  {threshold: [1]}
);

observer.observe(stickyElm)

// =============================================================================
// Trigger Tabs By Hash

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})

// =============================================================================
// == Wrap Last Word In Span =============

function targetLastWord(element)
{
    var pieces = element.innerHTML.split(" ");
    var last = pieces.pop();
    var first = pieces.join(" ");
    element.innerHTML = first + '<span class="last-word"> ' + last + '</span>';
}

var lastWords =  document.querySelectorAll(".last-word-bold");
lastWords.forEach(x => targetLastWord(x));


// =============================================================================
// == Split String =============

function splitStringByBreak(element) {

    // Split the string into words
    var pieces = element.innerHTML.split(/<br\s*\/?>/, 2);

    // Initialize arrays for the first and second halves
    var isTwoParts = pieces[1];
    var firstHalf = [];
    var secondHalf = [];

    if(isTwoParts){
        var firstHalf = [pieces[0]];
        var secondHalf = [pieces[1]];

        // Join the halves back into strings
        var first = firstHalf.join(' ');
        var last = secondHalf.join(' ');

        element.innerHTML = '<span class="first-part"> ' + first + '</span><span class="second-part"> ' + last + '</span>';
    }
    else {
        var firstHalf = [pieces[0]];
        var first = firstHalf.join(' ');

        element.innerHTML = '<span class="second-part"> ' + first + '</span>';
    }
}

var splitStrings = document.querySelectorAll(".split-string");
splitStrings.forEach(x => splitStringByBreak(x));

// =============================================================================
// == Focus on Search Open =============

const searchModal = document.getElementById('search-modal')
const searchInput = document.getElementById('modal-search')

searchModal.addEventListener('shown.bs.modal', () => {
    searchInput.focus()
})

// =============================================================================
// == Actual StickyNav Heights =============

    function updatePosition() {
        const mainNav = document.getElementById('site-nav');
        const subNav = document.getElementById('subnav');
        const overlayNav = document.body.classList.contains('overlay-nav');

        let stickyWNav = document.querySelectorAll('.sticky-w-nav');
        let stickyWSubnav = document.querySelectorAll('.sticky-w-subnav');

        // Set the top position of each target element based on the height of the reference element
        stickyWNav.forEach(function(stickyItem) {
            if(mainNav){
                let mainNavHeight = mainNav.clientHeight;
                stickyItem.style.top = mainNavHeight + 'px';
            }
        });
        stickyWSubnav.forEach(function(stickyItem) {
            if(mainNav && subNav){
                let mainNavHeight = mainNav.clientHeight;
                let subNavHeight = subNav.clientHeight;
                stickyItem.style.top = mainNavHeight + subNavHeight + 'px';
            }
        });

        if (overlayNav && window.innerWidth > 991) {
            mainNav.style.marginBottom = mainNav.clientHeight * -1 - 1 + 'px';
        } else {
             mainNav.style.marginBottom = 0;
        }
    }

    window.addEventListener('load', updatePosition);
    window.addEventListener('resize', updatePosition);

// =============================================================================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

// Abstracted event action handler
const doFancyboxOiEvent = (fancybox) => {
    let oi_event_name = false
    // Identify the proper event name. Use the first occurence from the possibilities
    // below.
    // 1. If a trigger element is available, use the value of data-oi-event-name when
    //    present. This is the most common scenario.
    // 2. If the Fancybox options object has oiEventName attribute, use the value. Event
    //    names are define this way when Fancybox assets are populated by a javascript
    //    array, and not DOM elements are available to place the data attribute.
    if (fancybox.options.$trigger
        && fancybox.options.$trigger.dataset
        && fancybox.options.$trigger.dataset.oiEventName) {
            oi_event_name = fancybox.options.$trigger.dataset.oiEventName
    }
    if (oi_event_name) {
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Define Fancybox config
window.FANCYBOX_CONFIG = {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", FANCYBOX_CONFIG)

/* END FANCYBOX */

// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);
